<template>
<div class="chapter">
<div class="inner_page">
<p class="h2"><a id="page_vii">CONTENTS</a></p><a id="page_vii">
</a><p class="toc-chapb"><a id="page_vii"></a><a href="#/html/9780226181608_07_ack#ack">Acknowledgments</a></p>
<p class="toc-chap"><a href="#/html/9780226181608_08_int#int">Introduction: War, Money, and American History</a></p>
<p class="toc-chap"><a href="#/html/9780226181608_09_ch1#ch1">1. A More Effectual Mode of Administration: The Constitution and the Origins of American Public Finance</a></p>
<p class="toc-chap"><span href="#/html/9780226181608_10_ch2#ch2" title="Link target outside of Sample">2. The Soul of Government: Creating an American Fiscal Regime</span></p>
<p class="toc-chap"><span href="#/html/9780226181608_11_ch3#ch3" title="Link target outside of Sample">3. So Immense a Power in the Affairs of War: The Restoration of Public Credit</span></p>
<p class="toc-chap"><span href="#/html/9780226181608_12_ch4#ch4" title="Link target outside of Sample">4. Equal to the Severest Trials: Mr. Madison’s War</span></p>
<p class="toc-chap"><span href="#/html/9780226181608_13_ch5#ch5" title="Link target outside of Sample">5. The Two Most Powerful Republics in the World: Mr. Polk’s War</span></p>
<p class="toc-chap"><span href="#/html/9780226181608_14_ch6#ch6" title="Link target outside of Sample">6. A Rank among the Very First of Military Powers: Mr. Lincoln’s War</span></p>
<p class="toc-chapb"><span href="#/html/9780226181608_15_con#con" title="Link target outside of Sample">Conclusion: The Ideology, Structure, and Significance of the First American Fiscal Regime</span></p>
<p class="toc-chap"><span href="#/html/9780226181608_16_not#not" title="Link target outside of Sample">Notes</span></p>
<p class="toc-chap"><span href="#/html/9780226181608_17_ind#ind" title="Link target outside of Sample">Index</span><a id="page_viii"></a></p><a id="page_viii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226181608_06_toc.vue?0976c324